import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';

export const OperatingDynamicsEvolutionChart = () => {
    const { chartData } = useIDCONSELHOChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual da Dinâmica de Funcionamento"
            subtitles={chartData.operatingDynamics.map((item) => getYearLabel(item.ano))}
            values={chartData.operatingDynamics.map(
                (item) => Number(item.dinamica_funcionamento) || 0
            )}
        />
    );
};
